import {
  CKEditorError as BaseCKEditorError,
  Editor as BaseEditor,
  EditorConfig as BaseEditorConfig,
  EventInfo as BaseEvent,
} from 'ckeditor5'
import { PlaceholderConstant } from '@pbt/pbt-ui-components'

import type {
  CorePluginName,
  CustomPluginName,
  RealTimePluginName,
} from '../plugins'

export type ToolbarItem =
  | '|'
  | 'bold'
  | 'bulletedList'
  | 'comment'
  | 'fontColor'
  | 'fontBackgroundColor'
  | 'heading'
  | 'imageUpload'
  | 'importNotesTemplate'
  | 'insertTable'
  | 'italic'
  | 'link'
  | 'numberedList'
  | 'placeholder'
  | 'redo'
  | 'revisionHistory'
  | 'todoList'
  | 'trackChanges'
  | 'undo'
  | 'underline'

export enum CommandName {
  INSERT_IMPORT_NOTES_TEMPLATE = 'insertImportNotesTemplate',
  INSERT_PLACEHOLDER = 'insertPlaceholder',
}

export type Editor = BaseEditor

export type PluginName = CorePluginName | CustomPluginName | RealTimePluginName

export type EditorConfig = BaseEditorConfig & {
  placeholderConfig?: { types: PlaceholderConstant[] }
}

export type Event = typeof BaseEvent

export type CKEditorError = BaseCKEditorError

export enum EditorType {
  CLASSIC = 'classic',
  BALLOON = 'balloon',
  INLINE = 'inline',
}

// TODO: This enum will be migrate to portal, so after all deploys we must remove it from this repo
export enum EditorDocumentType {
  DIAGNOSIS_HISTORY = 'diagnosis-history',
  SOAP_DISCHARGE = 'soap-discharge',
  SOAP_MEDICAL = 'soap-medical',
}
